module.exports = __webpack_public_path__ + "static/media/visa_debit.81ec5afb.png";